import React from 'react';
import { useAuth } from "../../../context/auth";
import {makeStyles} from "@material-ui/core/styles";
import DQCRTool_QuickCreatePage from "../Quick_Create/Quick_Create.dqcr_tool.page";

const useStyles = makeStyles((theme)=>({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: "center",
        marginTop: 10,
        marginBottom: 10
    },
}));

function DQCRTool_InteractiveCreatePage() {
    const classes = useStyles();

    const {authUser} = useAuth();

    return (
        <div className={classes.container}>
            <h3>Landed on Interactive Create Page</h3>
            <br />
            <p><b>Member_Id: {authUser.member_id}</b></p>
        </div>
    );
}

export default DQCRTool_InteractiveCreatePage;